export const getCroppedImg = async (imageSrc, pixelCrop) => {
  const image = new Image();
  // Necessário para evitar problemas de CORS com imagens externas
  image.setAttribute("crossOrigin", "anonymous");
  image.src = imageSrc;
  await new Promise((resolve) => {
    image.onload = resolve;
  });

  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  if (!ctx) {
    return null;
  }

  // Definir tamanho do canvas com base no corte
  canvas.width = pixelCrop.width;
  canvas.height = pixelCrop.height;

  // Desenhar o círculo para a máscara
  ctx.beginPath();
  ctx.arc(
    pixelCrop.width / 2,
    pixelCrop.height / 2,
    pixelCrop.width / 2,
    0,
    Math.PI * 2
  );
  ctx.closePath();
  ctx.clip(); // Limitar o desenho para dentro deste círculo

  // Desenhar a imagem ajustando sua posição relativa ao crop (suporta objectFit='contain')
  ctx.drawImage(
    image,
    -pixelCrop.x,
    -pixelCrop.y,
    image.naturalWidth,
    image.naturalHeight
  );

  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (!blob) {
        reject(new Error("Erro ao criar máscara (Canvas is empty)"));
        return;
      }
      // Adicionando uma extensão base para usar no nome caso precise
      blob.name = "cropped.png";
      resolve(blob);
    }, "image/png");
  });
};
